import { useMemo } from 'react';

import { UserPermissions } from '@arrived/auth';

import { useGetCurrentUserQuery } from './useGetCurrentUserQuery';
import { usePermissionsQuery } from './usePermissionsQuery';

export function useIsUserReferralBeta() {
  const currentUserState = useGetCurrentUserQuery();
  const permissions = usePermissionsQuery();

  return useMemo(() => {
    if (!currentUserState.isSuccess || !permissions.isSuccess) {
      return false;
    }

    return (
      currentUserState.data.admin ||
      permissions.data.includes(UserPermissions.ALL) ||
      permissions.data.includes(UserPermissions.REFERRAL_BETA)
    );
  }, [currentUserState, permissions]);
}
